import { Radio, RadioProps } from "semantic-ui-react";

type BPRadioProps = RadioProps & {}
export function BPRadio(props: BPRadioProps) {
    return <Radio {...props}>{props.children}</Radio>;
}